export enum CloseMethod {
  Expiration = 'E',
  Display = 'D',
  Action = 'A',
}

// API model

export interface ApiNotificationItem {
  id?: number;
  priority: number;
  closeMethod: CloseMethod;
  externalText?: string;
  externalButtonLabel1?: string;
  externalButtonLabel2?: string;
  externalCustomActionId?: string;
}

export interface ApiSetCgm90EnrollmentRequest {
  patientId: number;
  notificationId: number;
  consented: boolean;
}

// FE model

export interface Notification {
  id: number;
  priority: number;
  closeMethod: CloseMethod;
  text?: string;
  buttonLabel1?: string;
  buttonLabel2?: string;
  customActionId?: string;
}

// Mappers

export const mapNotifications = (apiNotificationItems: ApiNotificationItem[]): Notification[] => {
  return apiNotificationItems.map((n) => ({
    id: n.id!,
    priority: n.priority,
    closeMethod: n.closeMethod,
    text: n.externalText,
    buttonLabel1: n.externalButtonLabel1,
    buttonLabel2: n.externalButtonLabel2,
    customActionId: n.externalCustomActionId,
  }));
};
